import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserIdService } from '../../../auth';
import { normalizeHttpError } from '../../../util';
import { SiteFamilyConfigConnector } from '../../connectors/site-family-config-connector';
import { UserActions } from '../actions';
import { SiteFamilyConfigActions } from '../actions/site-family-config.action';
import { UserModuleLoadedActions } from '../actions/user.actions';

@Injectable()
export class SiteFamilyConfigEffects {
  loadSiteFamilyConfig$: Observable<SiteFamilyConfigActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.SiteFamilyConfigActionTypes.LoadSiteFamilyConfig),
      switchMap((action: UserActions.LoadSiteFamilyConfig) =>
        this.connector.load(action.userId).pipe(
          map((data) => new UserActions.LoadSiteFamilyConfigSuccess(data)),
          catchError((error) => of(new UserActions.LoadSiteFamilyConfigFail(normalizeHttpError(error))))
        )
      )
    )
  );

  loadSiteFamilyConfigAfterContextChange$: Observable<SiteFamilyConfigActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserModuleLoadedActions.USER_MODULE_LOADED),
      switchMap(() =>
        this.userIdService.takeUserId().pipe(
          map((userId) => new UserActions.LoadSiteFamilyConfig(userId)),
          catchError(() => EMPTY)
        )
      )
    )
  );

  constructor(private actions$: Actions, private connector: SiteFamilyConfigConnector, private userIdService: UserIdService) {}
}
